import React from 'react';
import { CartItem } from '@/contexts/CartContext'; // Assumindo que CartItem vem daqui
import { Loader2 } from 'lucide-react'; // Para o indicador de carregamento

interface OrderSummaryProps {
  cartItems: CartItem[];
  subtotal: number; // Alterado de totalPrice para subtotal
  deliveryFee: number; // Nova prop
  totalPrice: number; // Nova prop (subtotal + deliveryFee)
  isLoadingDeliveryFee: boolean; // Nova prop
}

const OrderSummary: React.FC<OrderSummaryProps> = ({ 
  cartItems, 
  subtotal, 
  deliveryFee, 
  totalPrice, 
  isLoadingDeliveryFee 
}) => {
  return (
    <div className="border rounded-md p-4 sticky top-24">
      <h2 className="text-lg font-semibold mb-4 border-b pb-3">Resumo do Pedido</h2>
      <div className="space-y-3 max-h-60 overflow-y-auto mb-4 pr-2">
        {cartItems.map(item => (
          <div key={item.product.id + (item.variant?.id || '')} className="flex justify-between items-center text-sm">
            <div className="flex items-center">
              <img 
                src={item.product.imageUrl || '/placeholder.svg'} 
                alt={item.product.name} 
                className="w-10 h-10 object-contain rounded mr-2 border bg-gray-100"
              />
              <div>
                <p className="font-medium">{item.product.name}</p>
                {item.variant && <p className="text-xs text-gray-500">{item.variant.name}</p>}
              </div>
            </div>
            <div className="text-right">
              <p>{item.quantity} x R$ {item.variant ? item.variant.price.toFixed(2) : item.product.price.toFixed(2)}</p>
              <p className="font-medium">
                R$ {(item.quantity * (item.variant ? item.variant.price : item.product.price)).toFixed(2)}
              </p>
            </div>
          </div>
        ))}
      </div>
      <div className="mt-4 pt-4 border-t space-y-2">
        <div className="flex justify-between text-sm">
          <span>Subtotal</span>
          <span>{subtotal.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</span>
        </div>
        
        <div className="flex justify-between text-sm">
          <span>Frete</span>
          {isLoadingDeliveryFee ? (
            <span className="flex items-center">
              <Loader2 className="h-4 w-4 animate-spin mr-1" /> Calculando...
            </span>
          ) : (
            <span>{deliveryFee.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</span>
          )}
        </div>

        {/* Linha opcional para mostrar se a taxa por KM não está disponível (pode ser adicionada no Checkout.tsx) */}
        {/* {deliveryConfig?.fee_type === 'per_km' && !isLoadingDeliveryFee && deliveryFee === 0 && (
          <p className="text-xs text-orange-600">Cálculo de entrega por KM será feito após o pedido.</p>
        )} */}

        <div className="flex justify-between font-semibold text-lg pt-2">
          <span>Total</span>
          <span>{totalPrice.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</span>
        </div>
      </div>
    </div>
  );
};

export default OrderSummary;
